import React, {useState} from "react";
import Histogram from "./Histogram";
import { TacticsData, Tactics, PopupData } from "../types/data";

interface Props {
  metric: Tactics;
  value: number;
  isEfficiency: boolean;
  isHome: boolean;
  handleData: React.Dispatch<React.SetStateAction<TacticsData>>;
  handleValue: (val: number) => void;
  popupData: PopupData;
  data: TacticsData;
  defaultData: TacticsData;
  setOpen: (val: boolean) => void;
}

const Popover: React.FC<Props> = ({ metric, value, data, defaultData, isEfficiency, isHome, handleData, handleValue, popupData, setOpen }) => {
  const [metricValue, setMetricValue] = useState(value);

  const updateMetricValue = () => {
    handleValue(metricValue);
    handleData((prevData) => {
      const newData = {...prevData};
      if (isEfficiency) {
        if (isHome) {
          newData.home[metric].efficiency = metricValue;
        } else {
          newData.away[metric].efficiency = metricValue;
        }
      } else {
        if (isHome) {
          newData.home[metric].usage = metricValue;
        } else {
          newData.away[metric].usage = metricValue;
        }
      }
      return newData;
    });
    setOpen(false);
  };

  const resetMetricValue = () => {
    let initial: number = 0;

    if (isEfficiency) {
      if (isHome) {
        initial = defaultData.home[metric].efficiency;
      } else {
        initial = defaultData.away[metric].efficiency;
      }
    } else {
      if (isHome) {
        initial = defaultData.home[metric].usage;
      } else {
        initial = defaultData.away[metric].usage;
      }
    }
    handleValue(initial);
    handleData((prevData) => {
      const newData = {...prevData};
      if (isEfficiency) {
        if (isHome) {
          newData.home[metric].efficiency = initial;
        } else {
          newData.away[metric].efficiency = initial;
        }
      } else {
        if (isHome) {
          newData.home[metric].usage = initial;
        } else {
          newData.away[metric].usage = initial;
        }
      }
      return newData;
    });
    setOpen(false);
  }

  return (
    <div className="inline-block rounded overflow-hidden shadow-lg min-w-min popup">
      <div className="px-6 py-4">
        <div className="flex justify-between items-center">
          <button className="px-4 py-2 bg-blue-900 hover:bg-blue-700 text-white rounded" onClick={() => updateMetricValue()}>
            Save
          </button>
          <p className="text-4xl">{metric}</p>
          <button className="px-4 py-2 bg-neutral-400 hover:bg-neutral-500 text-white rounded" onClick={() => resetMetricValue()}>
            Reset
          </button>
        </div>
        <div className="p-6">
          <Histogram
            popupData={popupData}
            numberOfIntervals={10}
            currentValue={metricValue}
            handleValue={setMetricValue}
          ></Histogram>
        </div>
        <div className="flex justify-between items-center">
          <p className="text-4xl text-red-700">League Games</p>
          <p className="text-4xl text-blue-300">Team Games</p>
        </div>
      </div>
    </div>
  );
};

export default Popover;
